import { createRoot } from "react-dom/client"
import { pdfjs } from "react-pdf"
import { configure } from "mobx"
import { ConfigProvider } from "antd"

import { App } from "@src/app"
import { setTheme } from "@src/app/styles/themes/setThreme"
import { theme, themeKey } from "@src/app/styles/themes/theme"
import "@src/app/styles/index.css"
import "./index.module.css"
import "@src/app/authStore/interceptor"

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

// https://mobx-cookbook.github.io/async-actions#settimeout-планировщика-реакций
configure({ enforceActions: "never" })

setTheme()

setTimeout(() =>
  configure({
    reactionScheduler: (f) => setTimeout(f),
  }),
)

createRoot(document.getElementById("root")!).render(
  <ConfigProvider theme={theme}>
    <App />
  </ConfigProvider>,
)
